/**
 * Read More Elementor widget: "… Read more" swaps the cut text for the full text, and "Read less" back.
 * Delegated, so it also works for widgets the Elementor editor re-renders.
 */
function setExpanded(widget, expanded) {
  const excerpt = widget.querySelector('.dmn-read-more__excerpt');
  const full = widget.querySelector('.dmn-read-more__full');
  if (!excerpt || !full) return;

  excerpt.hidden = expanded;
  full.hidden = !expanded;
  widget.classList.toggle('is-collapsed', !expanded);
  widget.classList.toggle('is-expanded', expanded);

  // Keep focus where the reader is: the full text after expanding, the "Read more" button after collapsing.
  if (expanded) {
    full.focus({ preventScroll: true });
  } else {
    excerpt.querySelector('.dmn-read-more__toggle--more')?.focus();
  }
}

export function initReadMore() {
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.dmn-read-more__toggle');
    const widget = toggle?.closest('.dmn-read-more');
    if (!widget) return;

    setExpanded(widget, toggle.classList.contains('dmn-read-more__toggle--more'));
  });
}
